var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.locationReviews && _vm.locationReviews.length)?_c('div',_vm._l((_vm.locationReviews),function(review,index){return _c('review-item',{key:index,attrs:{"item":review}})}),1):_c('div',[_c('empty-data',{attrs:{"iconColor":"#444","message":_vm.$t('empty.reviews'),"icon":"k-icon-star","textColor":"#000"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }